import Cookies from "js-cookie";
/**
 * storage localStorage
 */
export const setStore = (name, content, expireDay) => {
    if (!name) return;
    if (typeof content !== "string") {
        content = JSON.stringify(content);
    }
    Cookies.set(name, content, { expires: expireDay });
};

/**
 * Get localStorage
 */
export const getStore = name => {
    if (!name) return;
    let content = Cookies.get(name);
    try {
        content = JSON.parse(content);
        return content;
    } catch (e) {
        return content;
    }
};

/**
 * delete localStorage
 */
export const removeStore = name => {
    if (!name) return;
    Cookies.remove(name);
};